export function getAllChecked(source: boolean[]) {
    return source.reduce((previuous, next) => previuous &&= next)
}

export function isLungsFinished (isLungsAccepted: boolean | undefined, flags: boolean[])  {
    const accepted = isLungsAccepted ?? false
    const allFlagsChecked = getAllChecked(flags)
    return accepted ? allFlagsChecked :  true
}
